import { createContext, useContext } from "react"
import AudioRecorderPlayer from "~/ui/audio-recorder"

export const player = new AudioRecorderPlayer()
player.setSubscriptionDuration(0.1) // how long exectue callback
export const AudioPlayerContext = createContext<AudioRecorderPlayer>(player)

export const useAudioPlayer = () => useContext(AudioPlayerContext)
export const useAudioRecorder = useAudioPlayer
